import React from 'react';

import { CalendarContainerProps } from 'react-datepicker';

import { Box } from '@src/atoms/Box';
import { Icon } from '@src/atoms/Icon';

import styled from './DatePickerCustomContainer.scss';
import { classnames } from '@src/utils/classnames';
import { Divider } from '@src/atoms/Divider';
import { Text } from '@src/atoms/Text';

interface IProps extends CalendarContainerProps {
  helperDropdownText: string;
}

export const DatePickerCustomContainer = ({ children, className, helperDropdownText }: IProps) => {
  const rootClasses = classnames(styled.root, className);

  return (
    <Box column fullWidth className={rootClasses}>
      {children}
      <Box column paddingLeft={16} paddingRight={16} paddingBottom={16} gap={12}>
        <Divider />
        <Box fullWidth gap={4} alignItems="start">
          <Icon name="infoOutline" size="sm" view="basicGreySemiDark" />
          <Text id="helperText" size="caption" color="basicGreySemiDark">
            {helperDropdownText}
          </Text>
        </Box>
      </Box>
    </Box>
  );
};
